import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import React, { FC, FormEvent, useState } from 'react';
import classes from './SearchInput.module.scss';
import { Button, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

type SearchInputProps = {
  onTextChanged: (text: string) => void;
  placeholder?: string;
};
const SearchInput: FC<SearchInputProps> = ({ placeholder, onTextChanged }) => {
  const [name, setName] = useState('');

  const _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
    onTextChanged && onTextChanged(event.target.value);
  };

  const _onPressedClear = (event: FormEvent) => {
    event.preventDefault();
    setName('');
  };

  return (
    <Box component="form" noValidate autoComplete="on" className={classes.container}>
      <TextField
        className={classes.searchInput}
        id="outlined-controlled"
        label={placeholder || 'Search'}
        placeholder={placeholder || ''}
        value={name}
        onChange={_onChange}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={_onPressedClear}>
                  <HighlightOffIcon color="action" />
                </Button>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default SearchInput;
